module.exports = __webpack_public_path__ + "img/input4.b74d5dca.png";